module.exports = __webpack_public_path__ + "img/vif.ab920278.jpg";